import { defaultRegistry } from './defaultRegistry';

export { defaultRegistry };

export {
  createAuthRegistry,
  UNIFIED_ACCOUNT,
  DASHWORKS,
  DATASYNC,
  MCP,
  ZOOMINFO,
  DEFAULT_PROVIDER_KEY,
  PROVIDER_KEYS,
  type AuthProviderKey,
  type AuthRegistry,
  type WellKnownProviderKey,
  type ProviderRegistration,
  type SyncProviderRegistration,
  type AsyncProviderRegistration,
  type ProviderLoadType,
  type CreateAuthRegistryOptions,
  type I18nLoader,
  type LazyTranslationsSpork,
} from './registry';

export { useResolvedProvider } from './useResolvedProvider';

export const registerProvider = defaultRegistry.registerProvider;
export const unregisterProvider = defaultRegistry.unregisterProvider;
export const getComponentsSync = defaultRegistry.getComponentsSync;
export const resolveComponents = defaultRegistry.resolveComponents;
export const clearRegistry = defaultRegistry.clearRegistry;
